<template>
  <div class=" h-full">
  <div class="spin-loading" v-show="isLoading"><div style="border-top-color:transparent" class="w-11 h-11 border-4 border-green border-solid rounded-full animate-spin"></div></div>
    <div v-show="PaymentStatus.Unpaid" >
    <div
        class=" lg:min-h-screen bg-white lg:pt-0 pt-10 mx-auto px-4 flex flex-wrap justify-center"
    >
      <div
          class="mt-auto mb-auto w-px flex lg:space-x-2/12 lg:flex-row md:flex-col flex-col w-px sm:w-full relative z-40"
          style="width: 920px"
      >

        <div class="flex-1 mx-0 my-0 w-full md:w-1/2 md:mx-auto relative">
          <div class="flex flex-row space-x-8 md:space-x-0">
            <div class="flex flex-1 md:w-max-content md:flex-none my-auto">
              <button
                  class="flex items-center focus:outline-none"
                  @click="CancelModal"
              >
                <svg
                    id="Capa_1"
                    class="fill-current text-black w-4"
                    version="1.1"
                    viewBox="0 0 31.494 31.494"
                    x="0px"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    y="0px"
                >
                  <path
                      d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554
                                    c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587
                                    c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                  />
                </svg>
                <img
                    :src="businessUrl + merchantLogo"
                    alt=""
                    class="ml-2 w-6 h-6 rounded-full"
                />
                <span class="text-sm truncate relative left-3">{{
                    merchantName
                  }}</span>
              </button>
            </div>
            <div class="flex-1 items-center text-right my-auto md:hidden">
              <button
                  class="group inline-flex items-center space-x-2 text-base leading-5 focus:outline-none transition ease-in-out duration-150"
                  type="button"
                  @click="isOpen = !isOpen"
              >
                <span class="text-sm">More details</span>
                <svg
                    class="text-gray-400 h-5 w-5 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      clip-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      fill-rule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div class="overflow-hidden sm:rounded-md mt-10 hidden md:block Product-list-style">
            <product-list
                :products="products"
                :total-amount="totalAmount"
            ></product-list>
          </div>
<div  :total-amount="totalAmount"></div>
        </div>

        <div class="flex-1 mx-0 my-0 w-full md:w-1/2 md:mx-auto card-section">
          <div class="">
            <div class="mb-5 mt-10 md:mt-5 lg:mt-0">
              <h2 class="text-2xl tracking-tight leading-10">Pay with card</h2>
            </div>
            <validation-observer ref="paymentForm">
              <form @submit.prevent="InitiatePayment">
                <div class="mb-5">
                  <fieldset>
                    <legend
                        class="block text-sm font-medium leading-5 text-gray-700"
                    >
                      Card informations
                    </legend>
                    <div class="mt-1 bg-white rounded-md shadow-sm relative">
                      <validation-provider
                          v-slot="{ failed, errors }"
                          name="Card number"
                          rules="required|min:13"
                          vid="card"
                      >
                        <p
                            id="email-error"
                            class="absolute bottom-20 right-0 text-xs text-red-600 text-right normal-case"
                        >
                          {{ errors[0] }}
                        </p>
                        <div class="relative">
                          <input
                              :disabled="purchaseLoad"
                              type="text"
                              autocomplete="off"
                              inputmode="numeric"
                              v-model="cardInformation.cardNumber"
                              v-cleave="{
                              creditCard: true,
                              onCreditCardTypeChanged: cardChanged,
                            }"
                              :class="
                              !failed
                                ? ''
                                : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red'
                            "
                              aria-label="Card number"
                              class="form-input relative block w-full rounded-none rounded-t-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                              placeholder="Card number"
                          />
                          <transition-group
                              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                              enter-active-class="duration-150 ease-out"
                              enter-class="opacity-0 scale-95"
                              enter-to-class="opacity-100 scale-100"
                              leave-active-class="duration-100 ease-in"
                              leave-class="opacity-100 scale-100"
                              leave-to-class="opacity-0 scale-95"
                          >
                            <svg
                                v-show="
                                cardType === 'visa' ||
                                cardInformation.cardNumber === ''
                              "
                                :key="'visa'"
                                class="h-9 w-9"
                                clip-rule="evenodd"
                                fill-rule="evenodd"
                                viewBox="0 0 560 400"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                  d="m286.87 176.71c-.228 17.993 16.036 28.034 28.287 34.004 12.588 6.126 16.816 10.054 16.768 15.531-.096 8.384-10.042 12.083-19.35 12.227-16.24.252-25.681-4.384-33.188-7.891l-5.849 27.373c7.531 3.472 21.476 6.499 35.938 6.631 33.944 0 56.152-16.756 56.273-42.736.132-32.971-45.607-34.797-45.295-49.535.108-4.468 4.372-9.237 13.717-10.45 4.624-.612 17.392-1.081 31.866 5.585l5.681-26.484c-7.783-2.835-17.789-5.55-30.244-5.55-31.95 0-54.423 16.984-54.604 41.295m139.44-39.013c-6.198 0-11.423 3.616-13.753 9.165l-48.49 115.777h33.92l6.75-18.654h41.451l3.916 18.654h29.896l-26.089-124.942zm4.744 33.752 9.789 46.916h-26.809zm-185.31-33.752-26.737 124.942h32.322l26.725-124.942zm-47.817 0-33.644 85.04-13.609-72.308c-1.597-8.071-7.903-12.732-14.906-12.732h-54.999l-.769 3.628c11.291 2.45 24.119 6.402 31.89 10.63 4.756 2.582 6.114 4.84 7.675 10.978l25.776 99.706h34.161l52.369-124.942z"
                                  fill="#1a1f71"
                              />
                            </svg>
                            <svg
                                v-show="
                                cardType === 'mastercard' ||
                                cardInformation.cardNumber === ''
                              "
                                :key="'mastercard'"
                                class="h-9 w-9"
                                clip-rule="evenodd"
                                fill-rule="evenodd"
                                viewBox="0 0 560 400"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <clipPath id="a">
                                <path
                                    clip-rule="evenodd"
                                    d="m125.758 80h308.483v240h-308.483z"
                                />
                              </clipPath>
                              <g clip-path="url(#a)">
                                <path
                                    d="m428.163 316.746v.616h.575c.108.002.215-.025.309-.078.076-.054.12-.143.115-.236.004-.092-.039-.179-.115-.23-.093-.056-.2-.083-.309-.079h-.575zm.581-.437c.247-.015.491.056.691.201.163.133.253.336.243.546.007.18-.064.355-.195.479-.154.134-.348.215-.552.23l.771.879h-.594l-.709-.873h-.23v.873h-.497v-2.333h1.08zm-.154 3.14c.261.003.519-.05.758-.154.23-.099.439-.241.617-.418.177-.177.319-.386.418-.617.202-.489.202-1.038 0-1.527-.1-.23-.242-.439-.418-.617-.178-.177-.387-.319-.617-.418-.241-.098-.498-.148-.758-.145-.264-.002-.526.047-.771.145-.235.097-.45.239-.631.418-.557.571-.719 1.424-.412 2.16.094.231.234.441.412.617.182.178.396.32.631.418.244.104.506.156.771.154m0-4.473c.678-.001 1.329.265 1.813.74.233.228.418.5.546.801.266.622.266 1.328 0 1.951-.131.298-.316.57-.546.8-.237.227-.512.41-.813.54-.316.134-.656.203-1 .201-.347.002-.691-.066-1.012-.201-.304-.127-.582-.31-.819-.54-.23-.238-.413-.519-.538-.826-.266-.623-.266-1.329 0-1.952.127-.3.313-.572.546-.8.234-.234.512-.417.819-.54.32-.135.665-.203 1.012-.2m-236.183-8.987c0-4.449 2.916-8.105 7.68-8.105 4.553 0 7.626 3.498 7.626 8.105 0 4.608-3.073 8.106-7.626 8.106-4.764 0-7.68-3.656-7.68-8.106m20.496 0v-12.663h-5.505v3.085c-1.746-2.28-4.394-3.709-7.996-3.709-7.095 0-12.663 5.565-12.663 13.294s5.565 13.294 12.663 13.294c3.6 0 6.25-1.432 7.996-3.71v3.074h5.499v-12.665zm186.003 0c0-4.449 2.915-8.105 7.681-8.105 4.558 0 7.626 3.498 7.626 8.105 0 4.608-3.068 8.106-7.626 8.106-4.764 0-7.681-3.656-7.681-8.106m20.502 0v-22.827h-5.51v13.249c-1.746-2.28-4.394-3.709-7.995-3.709-7.096 0-12.664 5.565-12.664 13.294s5.565 13.294 12.664 13.294c3.601 0 6.249-1.432 7.995-3.71v3.074h5.51zm-138.182-8.366c3.547 0 5.826 2.225 6.407 6.141h-13.135c.588-3.656 2.807-6.141 6.729-6.141m.11-4.935c-7.419 0-12.609 5.398-12.609 13.294 0 8.05 5.398 13.294 12.978 13.294 3.812 0 7.305-.952 10.377-3.548l-2.698-4.079c-2.122 1.696-4.824 2.648-7.365 2.648-3.547 0-6.777-1.643-7.571-6.201h18.797c.054-.684.109-1.375.109-2.116-.055-7.892-4.935-13.294-12.021-13.294m66.463 13.294c0-4.45 2.915-8.105 7.679-8.105 4.554 0 7.626 3.498 7.626 8.105s-3.072 8.106-7.626 8.106c-4.764 0-7.681-3.656-7.681-8.106m20.496 0v-12.654h-5.502v3.085c-1.752-2.28-4.394-3.709-7.996-3.709-7.095 0-12.663 5.565-12.663 13.294s5.565 13.294 12.663 13.294c3.602 0 6.244-1.432 7.996-3.71v3.074h5.503v-12.665zm-51.582 0c0 7.68 5.346 13.294 13.506 13.294 3.812 0 6.353-.848 9.1-3.018l-2.644-4.45c-2.067 1.485-4.237 2.28-6.632 2.28-4.395-.054-7.626-3.232-7.626-8.106s3.231-8.05 7.626-8.105c2.389 0 4.559.794 6.632 2.279l2.644-4.449c-2.752-2.171-5.292-3.019-9.1-3.019-8.16 0-13.506 5.613-13.506 13.294m70.967-13.294c-3.176 0-5.244 1.485-6.674 3.71v-3.07h-5.456v25.314h5.511v-14.19c0-4.189 1.8-6.517 5.399-6.517 1.178-.017 2.348.2 3.442.637l1.697-5.188c-1.218-.48-2.807-.691-3.922-.691m-147.554 2.648c-2.648-1.746-6.298-2.648-10.323-2.648-6.414 0-10.543 3.074-10.543 8.104 0 4.127 3.074 6.674 8.735 7.468l2.6.37c3.019.424 4.444 1.219 4.444 2.648 0 1.958-2.005 3.075-5.77 3.075-3.813 0-6.565-1.219-8.42-2.649l-2.587 4.293c3.019 2.224 6.832 3.285 10.961 3.285 7.311 0 11.548-3.443 11.548-8.263 0-4.45-3.335-6.777-8.844-7.571l-2.595-.377c-2.383-.308-4.292-.788-4.292-2.485 0-1.85 1.8-2.964 4.82-2.964 3.231 0 6.359 1.218 7.892 2.17l2.383-4.45zm71.03-2.644c-3.176 0-5.244 1.486-6.668 3.71v-3.079h-5.456v25.314h5.505v-14.19c0-4.189 1.8-6.517 5.399-6.517 1.178-.017 2.348.2 3.442.637l1.697-5.188c-1.218-.48-2.807-.691-3.922-.691m-46.973.635h-9.002v-7.679h-5.565v7.679h-5.134v5.032h5.134v11.548c0 5.873 2.28 9.371 8.792 9.371 2.389 0 5.141-.74 6.887-1.957l-1.59-4.714c-1.643.952-3.443 1.432-4.874 1.432-2.752 0-3.65-1.697-3.65-4.237v-11.439h9.002zm-82.302 25.321v-15.887c0-5.983-3.813-10.009-9.959-10.063-3.232-.054-6.565.952-8.898 4.504-1.746-2.807-4.498-4.504-8.366-4.504-2.704 0-5.346.794-7.415 3.759v-3.13h-5.509v25.314h5.552v-14.036c0-4.394 2.437-6.729 6.201-6.729 3.655 0 5.505 2.383 5.505 6.674v14.088h5.565v-14.036c0-4.394 2.54-6.729 6.194-6.729 3.759 0 5.553 2.383 5.553 6.674v14.088z"
                                    fill="#231f20"
                                />
                                <path
                                    d="m431.302 234.43v-3.702h-.964l-1.115 2.54-1.109-2.54h-.967v3.702h.684v-2.789l1.043 2.406h.71l1.042-2.412v2.795h.679zm-6.116 0v-3.068h1.234v-.625h-3.153v.625h1.234v3.068z"
                                    fill="#f79410"
                                />
                                <path
                                    d="m321.733 250.306h-83.423v-149.923h83.425z"
                                    fill="#ff5f00"
                                />
                                <path
                                    d="m243.599 175.348c0-30.412 14.24-57.503 36.413-74.962-16.781-13.232-37.548-20.418-58.918-20.386-52.654 0-95.336 42.688-95.336 95.348 0 52.659 42.682 95.347 95.336 95.347 21.37.032 42.138-7.154 58.92-20.386-22.172-17.456-36.415-44.548-36.415-74.961"
                                    fill="#eb001b"
                                />
                                <path
                                    d="m434.28 175.348c0 52.659-42.682 95.347-95.335 95.347-21.373.031-42.143-7.154-58.928-20.386 22.18-17.459 36.42-44.548 36.42-74.961 0-30.414-14.24-57.503-36.42-74.962 16.784-13.232 37.554-20.417 58.926-20.386 52.654 0 95.336 42.688 95.336 95.348"
                                    fill="#f79410"
                                />
                              </g>
                            </svg>
                          </transition-group>
                        </div>
                      </validation-provider>

                      <div class="-mt-px flex">
                        <div class="w-1/2 flex-1 min-w-0 relative">
                          <validation-provider
                              v-slot="{ failed, errors }"
                              name="Date"
                              rules="required|min:6|card_date"
                          >
                            <input
                                :disabled="purchaseLoad"
                                type="text"
                                inputmode="numeric"
                                autocomplete="off"
                                v-model="cardInformation.date"
                                v-cleave="{
                                date: true,
                                delimiter: ' / ',
                                datePattern: ['m', 'y'],
                              }"
                                :class="
                                !failed
                                  ? ''
                                  : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red'
                              "
                                aria-label="Card expiration date"
                                class="form-input relative block w-full rounded-none rounded-bl-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                placeholder="MM / YY"
                            />
                            <p
                                id="date-error"
                                class="absolute left-0 text-xs text-red-600 text-right normal-case"
                            >
                              {{ errors[0] }}
                            </p>
                          </validation-provider>
                        </div>
                        <div class="-ml-px flex-1 min-w-0">
                          <validation-provider
                              v-slot="{ failed, errors }"
                              name="Card security number"
                              rules="required|min:3"
                          >
                            <input
                                :disabled="purchaseLoad"
                                v-model="cardInformation.cvv"
                                type="password"
                                inputmode="numeric"
                                v-cleave="{
                                blocks: [4],
                                numericOnly: true,
                              }"
                                :class="
                                !failed
                                  ? ''
                                  : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red'
                              "
                                aria-label="Card CVV"
                                autocomplete="new-password"
                                class="form-input relative block w-full rounded-none rounded-br-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                placeholder="CVV"
                            />
                            <p
                                id="cvv-error"
                                class="absolute right-0 text-xs text-red-600 text-right normal-case"
                            >
                              {{ errors[0] }}
                            </p>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="mt-10">
                  <label
                      class="block text-sm font-medium leading-5 text-gray-700"
                      for="holder"
                  >Name on card</label
                  >
                  <div class="mt-1 relative rounded-md shadow-sm relative">
                    <validation-provider
                        v-slot="{ failed, errors }"
                        name="Name on card"
                        rules="required|alpha_spaces|max:120"
                    >
                      <input
                          :disabled="purchaseLoad"
                          id="holder"
                          v-model="cardInformation.NameOnCard"
                          :class="
                          !failed
                            ? ''
                            : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red'
                        "
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          placeholder=""
                      />
                      <p
                          id="holder-error"
                          class="absolute bottom-10 right-0 text-xs text-red-600 text-right normal-case"
                      >
                        {{ errors[0] }}
                      </p>
                    </validation-provider>
                  </div>
                </div>
                 <div class="mt-5 warning-style" v-show="isCybersourceDown">
                   <img class="w-25 h-8 block" src="@/assets/images/Icon-warning.svg" alt="">
                   <p>You might face issues while paying with your credit cards due to network problems</p>
                </div>
                   <div class="mt-2 warning-style"  v-show="isOmanNetDown">
                   <img class="w-25 h-8 block" src="@/assets/images/Icon-warning.svg" alt="">
                   <p>You might face issues while paying with your debit cards due to network problems</p>
                </div>
                <div v-show="isCheckboxSeen" class="mt-5" v-if="isSaveCardAllowed">
                  <div class="flex items-start">
                    <div class="flex items-center h-5">
                      <input
                          id="save-card"
                          v-model="cardInformation.saveCard"
                          class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                          type="checkbox"
                          :disabled="isAutoSaveCard === true"
                          checked="checked"
                      />
                    </div>
                    <div class="ml-3 text-sm leading-5">
                      <label class="font-medium text-gray-700" for="save-card"
                      >Save for future payments</label
                      >
                    </div>
                  </div>
                </div>
                <div v-show="cardInformation.saveCard" class="mt-2">
                  <label
                      class="block text-sm font-medium leading-5 text-gray-700"
                      for="holder"
                  >Nickname</label
                  >
                  <div class="mt-1 relative rounded-md shadow-sm relative">
                    <validation-provider
                        v-slot="{ failed, errors }"
                        :rules="cardInformation.saveCard ? 'required|alpha_spaces|max:40' : ''"
                        name="nickname"
                    >
                      <input
                          :disabled="purchaseLoad"
                          id="nickname"
                          v-model="cardInformation.nickname"
                          :class="
                          !failed
                            ? ''
                            : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red'
                        "
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          placeholder=""
                      />
                      <p
                          id="nickname-error"
                          class="absolute bottom-10 right-0 text-xs text-red-600 text-right normal-case"
                      >
                        {{ errors[0] }}
                      </p>
                    </validation-provider>
                  </div>
                </div>
                <p v-show="isFailed" class="text-red-600 text-sm font-medium leading-5 normal-case">Your payment has failed, please try again.</p>
                <div class="mt-5 md:mb-0">
                  <span class="block w-full rounded-md shadow-sm">
                    <button
                        :disabled="purchaseLoad || isSuccess"
                        class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md transition duration-150 ease-in-out text-white primary-btn"
                        :class="!purchaseLoad ? 'bg-green-500 hover:bg-green-400 focus:outline-none focus:bg-green-600 focus:shadow-outline-green active:bg-green-600' : 'bg-gray-500' "
                        type="submit"
                    >
                      <span v-show="!purchaseLoad && !isSuccess">
                        Pay {{ (totalAmount / 1000).toFixed(3) }} OMR
                      </span>
                      <svg
                          v-show="purchaseLoad"
                          class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          fill="none"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                        ></circle>
                        <path
                            class="opacity-75"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            fill="currentColor"
                        ></path>
                      </svg>
                      <span v-show="purchaseLoad"> Processing </span>
                      <svg
                          v-show="isSuccess"
                          class="-ml-1 mr-3 h-5 w-5 text-white fill-current"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
                        />
                      </svg>
                      <span v-show="isSuccess"> Successful </span>
                    </button>
                  </span>
                </div>
              </form>
            </validation-observer>
              <div class="text-center mt-6 md:mb-0">
                <button class="text-sm focus:outline-none border-none " :class="purchaseLoad ? 'text-gray-500 pointer-events-none' : 'text-red-500'" @click="CancelModal">Cancel</button>
              </div>

          </div>
        </div>
      </div>
    </div>
    <div
        class="lg:min-h-screen bg-white w-1/2 absolute right-0 top-0 shadow-box"
    ></div>
    <transition
        enter-active-class="duration-150 ease-ou"
        enter-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="duration-100 ease-in"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
    >
      <div
          v-show="isOpen"
          class="absolute top-20 inset-x-0 transition transform origin-top-right md:hidden z-40"
      >
        <div class="rounded-lg shadow-md">
          <div
              aria-labelledby="main-menu"
              aria-orientation="vertical"
              class="rounded-lg bg-white shadow-xs overflow-hidden"
              role="menu"
          >
            <div class="overflow-hidden sm:rounded-md px-11">
              <product-list
                  :products="products"
                  :total-amount="totalAmount"
              ></product-list>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0">
      <div v-if="showOtp" class="fixed z-50 inset-0 overflow-y-auto">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
          <transition
              enter-active-class="ease-out duration-300"
              enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enter-to-class="opacity-100 translate-y-0 sm:scale-100"
              leave-active-class="ease-in duration-200"
              leave-class="opacity-100 translate-y-0 sm:scale-100"
              leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
                aria-labelledby="modal-headline"
                aria-modal="true"
                class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6"
                role="dialog">
              <div class="sm:block absolute top-0 right-0 pt-4 pr-4">
                <button aria-label="Close"
                        v-show="!otpLoad"
                        class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
                        type="button"
                        @click="OtpModal">
                  <!-- Heroicon name: x -->
                  <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                </button>
              </div>
              <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100">
                <svg class="h-12 w-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 32 32"
                     xmlns="http://www.w3.org/2000/svg">
                  <path class="st0"
                        d="M20,17h-8c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h8c1.1,0,2,0.9,2,2v4C22,16.1,21.1,17,20,17z"/>
                  <path class="st0" d="M20,9h-8V5c0-2.2,1.8-4,4-4h0c2.2,0,4,1.8,4,4V9z"/>
                  <line class="st0" x1="16" x2="16" y1="12" y2="14"/>
                  <line class="st0" x1="16" x2="16" y1="22" y2="25"/>
                  <line class="st0" x1="13.1" x2="16" y1="24.1" y2="25"/>
                  <line class="st0" x1="14.2" x2="16" y1="27.4" y2="25"/>
                  <line class="st0" x1="17.8" x2="16" y1="27.4" y2="25"/>
                  <line class="st0" x1="18.9" x2="16" y1="24.1" y2="25"/>
                  <line class="st0" x1="26" x2="26" y1="22" y2="25"/>
                  <line class="st0" x1="23.1" x2="26" y1="24.1" y2="25"/>
                  <line class="st0" x1="24.2" x2="26" y1="27.4" y2="25"/>
                  <line class="st0" x1="27.8" x2="26" y1="27.4" y2="25"/>
                  <line class="st0" x1="28.9" x2="26" y1="24.1" y2="25"/>
                  <line class="st0" x1="6" x2="6" y1="22" y2="25"/>
                  <line class="st0" x1="3.1" x2="6" y1="24.1" y2="25"/>
                  <line class="st0" x1="4.2" x2="6" y1="27.4" y2="25"/>
                  <line class="st0" x1="7.8" x2="6" y1="27.4" y2="25"/>
                  <line class="st0" x1="8.9" x2="6" y1="24.1" y2="25"/>
                </svg>
              </div>
              <validation-observer ref="otpForm">
                <form @submit.prevent="ProceedWithOTP">
                  <div class="mt-3 text-center sm:mt-5">
                    <h3 id="modal-headline" class="text-lg leading-6 font-medium text-gray-900">
                      Authorize your payment
                    </h3>
                    <div class="mt-2">
                      <div class="mt-10">
                        <div class="mt-2">
                          <label
                              class="block text-left text-sm font-medium leading-5 text-gray-700"
                              for="otp"
                          >Please enter your OTP received from bank</label
                          >
                        </div>
                        <div class="mt-1 relative rounded-md shadow-sm relative">
                          <validation-provider
                              v-slot="{ failed, errors }"
                              name="otp"
                              rules="required"
                          >
                            <input
                                id="otp"
                                v-model="otp"
                                type="text"
                                autocomplete="off"
                                inputmode="numeric"
                                v-cleave="{
                                    blocks: [6],
                                    numericOnly: true,
                                  }"
                                :class=" !failed ? '' : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red'"
                                class="form-input relative block w-full rounded-none rounded-br-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            />
                            <p
                                id="otp-error"
                                class="absolute top-10 left-0 text-xs text-red-600 text-right normal-case"
                            >
                              {{ errors[0] }}
                            </p>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-5 sm:mt-6">
                  <span class="flex w-full rounded-md shadow-sm">
                    <button
                        :disabled="otpLoad"
                        class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                        type="submit">
                      <span v-show="!otpLoad">
                        Verify
                      </span>
                      <svg
                          v-show="otpLoad"
                          class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          fill="none"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                        ></circle>
                        <path
                            class="opacity-75"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            fill="currentColor"
                        ></path>
                      </svg>
                      <span v-show="otpLoad"> Verifying </span>
                    </button>
                  </span>
                  </div>
                </form>
              </validation-observer>
            </div>
          </transition>
        </div>
      </div>
    </transition>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0">
      <div v-show="show3dSecure" class="fixed z-50 inset-0 overflow-y-auto">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
          <transition
              enter-active-class="ease-out duration-300"
              enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enter-to-class="opacity-100 translate-y-0 sm:scale-100"
              leave-active-class="ease-in duration-200"
              leave-class="opacity-100 translate-y-0 sm:scale-100"
              leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
                aria-labelledby="modal-headline"
                aria-modal="true"
                class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl overflow-hidden transform transition-all sm:my-8 sm:align-middle w-full sm:max-w-md sm:w-full sm:p-6"
                role="dialog">
              <div class="sm:block absolute top-0 right-0 pt-4 pr-4">
                <button aria-label="Close"
                        class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
                        type="button"
                        @click="dSecureModal">
                  <!-- Heroicon name: x -->
                  <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                </button>
              </div>
              <div class="mt-5 sm:mt-6 overflow-x-auto">
                <!-- The Payment iFrame -->
                <iframe frameborder="0" width="390" height="400" name="payment-iframe"></iframe>
                <!-- The Device Data Collection iFrame. Required for 3DS 2.0 -->
                <iframe name="cardinal-collection-iframe" height="10" width="10" style="display:none;"></iframe>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
       <div v-if="showCancelModal" class="fixed z-50 inset-0 bg-gray-100 bg-opacity-25 overflow-y-auto h-full w-full" id="my-modal">
      <div class="relative z-10 " aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
        <div class="fixed z-10 inset-0 overflow-y-auto">
          <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <div class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
              <div>
                <div class="mt-3 text-center sm:mt-5">
                  <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">Are you sure you want to cancel?</h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">You are about to cancel the transaction. Please note that once you click on "Proceed" the link will not be valid anymore.</p>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense ">
                <button type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-500 hover:bg-green-400  text-base font-medium text-white  sm:col-start-2 sm:text-sm primary-btn"
                 :href="cancelUrl"
                  :disabled="purchaseLoad"
                  @click.prevent="cancelSession">
                     <svg
                          v-show="isCancel"
                          class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          fill="none"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                        ></circle>
                        <path
                            class="opacity-75"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            fill="currentColor"
                        ></path>
                      </svg>
                  Proceed
                  </button>
                <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      @click="CancelModal" >No</button>
              </div>
            </div>
          </div>
        </div>
      </div>
     </div>
    </div>

 <div class="bg-white" v-show="PaymentStatus.Cancelled">
    <div class="container mx-auto px-4 my-auto">
      <section class="py-8 px-4 text-center mx-auto">
        <div class="max-w-auto mx-auto mt-auto flex-row">
          <div class="md:max-w-lg mx-auto w-full"><img class="w-full block img-404" src="@/assets/images/Canceled_Payment.svg" alt=""></div>
          <div class="body-404 mx-auto">
            <h2 class="mt-8  text-xl lg:text-3xl font-black header-msg my-2">Cancelled Payment</h2>
            <p  class=" list-item">You've cancelled the payment</p>
          </div>
        </div>
      </section>
    </div>
  </div>
   <div class="bg-white" v-show="PaymentStatus.Paid">
    <div class="container mx-auto px-4 my-auto">
      <section class="py-8 px-4 text-center mx-auto">
        <div class="max-w-auto mx-auto mt-auto flex-row">
          <div class="md:max-w-lg mx-auto w-full"><img class="w-full block img-404" src="@/assets/images/Paid_successfully.svg" alt=""></div>
          <div class="body-404 mx-auto">
            <h2 class="mt-8  text-xl lg:text-3xl font-black header-msg my-2">Paid successfully</h2>
            <p  class=" list-item">You 've paid sucessfully</p>
          </div>
        </div>
      </section>
    </div>
  </div>
     <div class="bg-white" v-show="PaymentStatus.Expired">
    <div class="container mx-auto px-4 my-auto">
      <section class="py-8 px-4 text-center mx-auto">
        <div class="max-w-auto mx-auto mt-auto flex-row">
          <div class="md:max-w-lg mx-auto w-full"><img class="w-full block img-time-out" src="@/assets/images/time-out.svg" alt=""></div>
          <div class="body-404 mx-auto">
            <h2 class="mt-8  text-xl lg:text-3xl font-black header-msg my-2">Session expired</h2>
            <p  class=" list-item">This session has expired !</p>
          </div>
        </div>
      </section>
    </div>
  </div>
        <powered-by />
  </div>
</template>
<script>
import ProductList from '../components/ProductList'
import PoweredBy from '../components/PoweredBy'
import Checkout from '../API/Checkout'

const checkout = new Checkout()
export default {
  name: 'Home',
  components: {
    ProductList,
    PoweredBy
  },
  data () {
    return {
      PaymentStatus: { Unpaid: false, Paid: false, Cancelled: false, Expired: false },
      isLoading: false,
      isCancel: false,
      isOpen: false,
      cardInformation: {
        cardNumber: '',
        date: '',
        cvv: '',
        NameOnCard: '',
        saveCard: false,
        nickname: ''
      },
      cardType: '',
      products: [],
      totalAmount: 0,
      merchantName: '',
      merchantLogo: '',
      businessUrl: process.env.VUE_APP_MERCHANT_URL,
      cancelUrl: '',
      successUrl: '',
      purchaseLoad: false,
      isCybersourceDown: false,
      showCancelModal: false,
      isOmanNetDown: false,
      isSuccess: false,
      isSaveCardAllowed: false,
      isAutoSaveCard: false,
      paymentPageStatus: null,
      showOtp: false,
      otpLoad: false,
      show3dSecure: false,
      otp: '',
      receiptId: '',
      merchantId: '',
      cyberSourceOrganizationId: process.env.VUE_APP_CYBERSOURCE_ORGANIZATION_ID,
      paymentId: '',
      hash: '',
      isFailed: false,
      isCheckboxSeen: false
    }
  },
  methods: {
    cardChanged (type) {
      this.cardType = type
    },
    InitiatePayment () {
      this.isFailed = false
      this.$refs.paymentForm.validate().then(async (success) => {
        if (!success) {
          if (this.cardType === 'unknown') {
            this.$refs.form.setErrors({
              card: ['Card number is invalid']
            })
          }
          return
        }
        try {
          this.purchaseLoad = true
          const response = await checkout.InitializePaymentAsync(
            this.$route.params.session,
            this.$route.query.key,
            this.cardInformation
          )
          if (response.data.code === 2100) {
            this.isSuccess = true
            setTimeout(() => {
              window.location.href = this.successUrl
            }, 1000)
          // OmanNet
          } else if (response.data.code === 2101) {
            this.showOtp = true
            this.otp = ''
            this.hash = response.data.data.hash
            this.receiptId = response.data.data.receipt_id
            this.paymentId = response.data.data.payment_id
            return
          // CyberSource
          } else if (response.data.code === 2102) {
            // Start the Device Data collection procedure
            this.merchantId = response.data.data.merchant_id
            this.receiptId = response.data.data.receipt_id
            const form = document.createElement('form')
            form.target = 'cardinal-collection-iframe'
            form.method = 'POST'
            form.action = response.data.data.device_data_collection_url
            const accessTokenElement = document.createElement('input')
            accessTokenElement.type = 'hidden'
            accessTokenElement.value = response.data.data.access_token
            accessTokenElement.name = 'JWT'
            form.appendChild(accessTokenElement)
            document.body.appendChild(form)
            form.submit()
            form.remove()
            // Remove the existing element (if any)
            if (document.getElementById('deviceFingerprint') != null) {
              document.getElementById('deviceFingerprint').remove()
            }
            const deviceFingerPrintScript = document.createElement('script')
            deviceFingerPrintScript.id = 'deviceFingerprint'
            deviceFingerPrintScript.type = 'text/javascript'
            deviceFingerPrintScript.src = 'https://h.online-metrix.net/fp/tags.js?org_id=' + this.cyberSourceOrganizationId + '&session_id=' + this.merchantId + this.receiptId
            document.body.appendChild(deviceFingerPrintScript)
            // Remove the existing element (if any)
            if (document.getElementById('deviceFingerprintNoScript') != null) {
              document.getElementById('deviceFingerprintNoScript').remove()
            }
            const deviceFingerprintNoScript = document.createElement('noscript')
            deviceFingerprintNoScript.id = 'deviceFingerprintNoScript'
            const deviceFingerPrintIFrame = document.createElement('iframe')
            deviceFingerPrintIFrame.style = 'width: 100px; height: 100px; border:0; position: absolute; top: -500px;'
            deviceFingerPrintIFrame.src = 'https://h.online-metrix.net/fp/tags.js?org_id=' + this.cyberSourceOrganizationId + '&session_id=' + this.merchantId + this.receiptId
            deviceFingerPrintIFrame.id = 'deviceFingerprintIFrame'
            deviceFingerprintNoScript.appendChild(deviceFingerPrintIFrame)
            document.body.appendChild(deviceFingerprintNoScript)
            return
          } else {
            this.$refs.paymentForm.setErrors({
              card: ['Your card declined, please use different card.']
            })
          }
          this.purchaseLoad = false
        } catch (ex) {
          console.log(ex)
          this.purchaseLoad = false
        }
      })
    },
    async EnrollAuthentication (referenceId) {
      try {
        const response = await checkout.EnrollAuthenticationAsync(
          this.receiptId,
          referenceId
        )
        if (response.data.success) {
          if (response.data.data.step_up_url == null) {
            var validateAuthenticationResponse = await checkout.ValidateAuthenticationAsync('Validate without OTP', response.data.data.authentication_transaction_id, response.data.data.receipt_id)
            await this.confirm3ds2Payment(validateAuthenticationResponse.data.success)
          } else {
            const form = document.createElement('form')
            form.target = 'payment-iframe'
            form.method = 'POST'
            form.action = response.data.data.step_up_url
            const jwtElement = document.createElement('input')
            const mdElement = document.createElement('input')
            jwtElement.type = 'hidden'
            jwtElement.value = response.data.data.access_token
            jwtElement.name = 'JWT'
            mdElement.type = 'hidden'
            mdElement.value = this.receiptId
            mdElement.name = 'MD'
            form.appendChild(jwtElement)
            form.appendChild(mdElement)
            document.body.appendChild(form)
            form.submit()
            form.remove()
            this.show3dSecure = true
          }
        } else {
          this.$refs.paymentForm.setErrors({
            card: ['Your card declined, please use different card.']
          })
          this.purchaseLoad = false
        }
      } catch (ex) {
        console.log(ex)
        this.purchaseLoad = false
      }
    },
    async ProceedWithOTP () {
      const result = await this.$refs.otpForm.validate()
      if (!result) {
        return
      }
      try {
        this.otpLoad = true
        const OTPResponse = await checkout.AuthorizedPaymentAsync(
          this.$route.params.session,
          this.$route.query.key,
          this.receiptId,
          this.paymentId,
          this.otp
        )
        if (OTPResponse.data.success) {
          await this.confirmPayment(true, true)
        } else {
          if (OTPResponse.data.code === 4206) {
            this.$refs.paymentForm.setErrors({
              card: ['Your card otp failed! please try again.']
            })
          } else {
            this.$refs.paymentForm.setErrors({
              card: ['Your card declined, please use different card.']
            })
          }
          this.receipt_id = ''
          this.payment_id = ''
          this.otp = ''
          this.otpLoad = false
          this.showOtp = false
          this.isSuccess = false
          this.purchaseLoad = false
        }
      } catch (ex) {
        this.receipt_id = ''
        this.payment_id = ''
        this.otp = ''
        this.otpLoad = false
        this.showOtp = false
        this.purchaseLoad = false
      }
    },
    async cancelSession () {
      try {
        this.isCancel = true
        const response = await checkout.cancelSessionAsync(
          this.$route.params.session,
          this.$route.query.key
        )
        if (response.status === 200) {
          window.location.href = this.cancelUrl
          this.isCancel = false
        }
      } catch (ex) {
        alert("You can't cancel in process transaction")
        this.isCancel = false
      }
    },
    OtpModal () {
      this.showOtp = !this.showOtp
      if (!this.showOtp) {
        this.purchaseLoad = false
        this.otp = ''
        this.receipt_id = ''
        this.payment_id = ''
      }
    },
    CancelModal () {
      this.showCancelModal = !this.showCancelModal
    },
    dSecureModal () {
      this.show3dSecure = !this.show3dSecure
      if (!this.show3dSecure) {
        this.purchaseLoad = false
        this.receipt_id = ''
        this.payment_id = ''
      }
    },
    async confirm3ds2Payment (isSuccess) {
      this.show3dSecure = false
      this.receipt_id = ''
      this.payment_id = ''
      this.purchaseLoad = false
      if (isSuccess) {
        this.isSuccess = true
        setTimeout(() => { window.location.href = this.successUrl }, 1000)
      } else {
        this.isSuccess = false
        this.isFailed = true
      }
    },
    async confirmPayment (isDebit, isSuccess) {
      if (isSuccess) {
        if (isDebit) {
          this.showOtp = false
          this.receipt_id = ''
          this.payment_id = ''
          this.otp = ''
          this.isSuccess = true
          this.purchaseLoad = false
          this.otpLoad = false
        } else {
          this.show3dSecure = false
          this.receipt_id = ''
          this.payment_id = ''
          this.isSuccess = true
          this.purchaseLoad = false
        }
        setTimeout(() => {
          window.location.href = this.successUrl
        }, 1000)
      } else {
        if (isDebit) {
          this.showOtp = false
          this.receipt_id = ''
          this.payment_id = ''
          this.otp = ''
          this.isSuccess = false
          this.purchaseLoad = false
          this.otpLoad = false
        } else {
          this.show3dSecure = false
          this.receipt_id = ''
          this.payment_id = ''
          this.isSuccess = false
          this.purchaseLoad = false
        }
        this.isFailed = true
      }
    }
  },
  async mounted () {
    window.addEventListener('message', async (event) => {
      if (event.origin !== process.env.VUE_APP_BASE_URL && event.origin !== process.env.VUE_APP_CARDINAL_DATA_COLLECTION_URL) {
        return
      }
      if (event.origin === process.env.VUE_APP_CARDINAL_DATA_COLLECTION_URL) {
        var eventDataJson = JSON.parse(event.data)
        await this.EnrollAuthentication(eventDataJson.SessionId)
      }
      if (event.data === '1' || event.data === '0') {
        await this.confirm3ds2Payment(event.data === '1')
      }
    })
    if (typeof this.$route.query.key === 'undefined') {
      await this.$router.push({
        path: '/404'
      })
    }
    try {
      this.isLoading = true
      const response = await checkout.getCheckoutDetailsAsync(
        this.$route.params.session,
        this.$route.query.key
      )
      this.products = response.data.products
      this.totalAmount = response.data.total_amount
      this.merchantName = response.data.merchant
      this.merchantLogo = response.data.logo
      this.cancelUrl = response.data.cancel_url
      this.successUrl = response.data.success_url
      this.isSaveCardAllowed = response.data.is_save_card_allowed
      this.isCheckboxSeen = this.isSaveCardAllowed
      this.isAutoSaveCard = response.data.auto_save_card
      this.paymentPageStatus = response.data.payment_page_status
      this.isCybersourceDown = response.data.alert_cyber_source
      this.isOmanNetDown = response.data.alert_oman_net
      if (this.isAutoSaveCard === true) {
        this.cardInformation.saveCard = true
      }
      if (this.paymentPageStatus === 1) {
        this.isLoading = false
        this.PaymentStatus = { Unpaid: true, Paid: false, Cancelled: false, Expired: false }
      }
      if (this.paymentPageStatus === 2) {
        this.isLoading = false
        this.PaymentStatus = { Unpaid: false, Paid: true, Cancelled: false, Expired: false }
      }
      if (this.paymentPageStatus === 3) {
        this.isLoading = false
        this.PaymentStatus = { Unpaid: false, Paid: false, Cancelled: true, Expired: false }
      }
      if (this.paymentPageStatus === 4) {
        this.isLoading = false
        this.PaymentStatus = { Unpaid: false, Paid: false, Cancelled: false, Expired: true }
      }
    } catch (ex) {
      this.isLoading = false
    }
  }
}

</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
*{
 font-family: 'Poppins', sans-serif;
}
.warning-style p{
  text-align: left;
  font-style: normal;
  font-variant-caps: normal;
  font-weight: 300;
  font-stretch: normal;
  font-size: 14px;
  font-family: 'Helvetica Neue';
  letter-spacing: 0px;
  color: #444444;
  opacity: 1;
}
.warning-style{
  background: #fff3ca;
  border-radius: 0.375rem;
  padding:0.5rem 0.75rem;
  display:grid;
  grid-template-columns: 25px 1fr;
  gap:12px;
  line-height: 1.3;
}
.warning-style img{
 width: 23px;
}
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
.header-msg{
  text-transform: capitalize;
  font-weight: 500;
  font-stretch: normal;
  font-size: 30px;
  font-family: 'Poppins' , sans-serif;
  text-align: center;
  margin:1rem 0;
}
.list-item{
text-align: center;
font-family: 'Poppins' , sans-serif;
font-stretch: normal;
color: #444444;
font-size: 15px;
opacity: 1;
font-weight: 300;
line-height: 2;
margin-left: 11px;
}
section{
  max-width: 600px;
  width: 100%;
  padding-top: 10%;
}
.img-404{
  padding-top: 10%;
  width: 50%;
  margin: auto;
}
.body-404{
width: 90%;
}
.img-time-out {
  width: 30%;
  margin: auto;
}

@media only screen and (max-height: 600px) {
.img-404{
    padding-top: 0%;
  width: 30%;
}
 .header-msg {
   font-size: 14px;
  }
  .list-item{
    font-size: 12px;
  }
  section{
    padding-top: 10%;

  }
  .card-section{
    margin-bottom: 10%;
  }

}
@media only screen and (max-width: 992px) and (min-height: 601px){
  .img-404{
  width: 60%;
  }
  .header-msg {
   font-size: 18px;
  }
  .list-item{
    font-size: 12px;
  }
  section{
  padding-top: 30%;
  }
  .body-404{
  width: 73%;
  }
  .img-time-out {
  width: 20%;
  margin: auto;
}
}
.form-input::placeholder {
  color: #9fa6b2;
  opacity: 1;
  font-size: 12px !important;
}
.primary-btn{
  background: #6fbf49;
}
.primary-btn:hover{
 background: #85d360;
}
.shadow-box{
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.04);
}
.border-green{
  border-color:#6fbf49;
}
.spin-loading{
width: 100vw;
height: 100vh;
background: rgba(255, 255, 255, 0.75);
display:grid;
position: absolute;
top: 0;
bottom: 0;
left: 0;
right: 0;
z-index: 12121212;
display: grid;
place-items: center;
}
.Product-list-style{
  max-height: 370px;
  height: 100%;
  overflow: auto;
}

</style>
